import { render, staticRenderFns } from "./BatchUserCreationParameter.vue?vue&type=template&id=10d975c1"
import script from "./BatchUserCreationParameter.vue?vue&type=script&lang=js"
export * from "./BatchUserCreationParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports